import { Descriptions, DescriptionsProps, Divider, Form, InputNumber, Modal, notification } from "antd"
import { RequirementDetailType } from "../hooks/useGetDetail";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { itemUpdate } from "@/apis/requirement";
import { RequirementItem } from "@/types/requirement";
import { itemUpdateByKey, itemUpdate as purItemUpdate } from "@/apis/purchase";
import { numFormmater } from "@/pages/Requirement/util";

interface ItemInfoProps {
  item: RequirementDetailType;
  onClose: () => void;
  onSuccessCb: (reqItem: RequirementItem) => void;
}

interface FieldType {
  useAmount: number;
  purCount: number;
  bomAmount: number;
}
const ItemInfo: React.FC<ItemInfoProps> = ({ item, onClose, onSuccessCb }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<FieldType>();

  const [okLoading, setOkLoading] = useState<boolean>(false);

  const desc: DescriptionsProps["items"] = [
    {
      key: "productCode",
      label: t("product.code"),
      children: item?.product?.code,
      span: 1
    },
    {
      key: "productName",
      label: t("product.name"),
      children: item?.product?.name,
      span: 1
    },
    {
      key: "productModel",
      label: t("product.uom"),
      children: item?.product?.uom,
      span: 1
    },
    {
      key: "productModel",
      label: t("product.brand1"),
      children: item?.product?.model,
      span: 3
    },
  ]

  useEffect(() => {
    form.setFieldsValue({
      useAmount: Number(item?.useAmount ?? '0'),
      purCount: Number(item?.purCount ?? '0'),
      bomAmount: Number(item?.bomAmount ?? '0'),
    })
  }, [item]);

  const submit = (values: FieldType) => {
    const { useAmount, purCount, bomAmount } = values;
    if (purCount > useAmount) {
      form.setFields([
        { name: 'purCount', errors: [t('requirement.purCountErr')] },
      ]);
      return;
    }
    if (!!!bomAmount) {
      form.setFields([
        { name: 'bomAmount', errors: [t('requirement.bomAmountErr')] },
      ]);
      return;
    }
    setOkLoading(true);
    itemUpdate(item.id, {
      // ...item,
      extCount: item.extCount,
      productId: item.productId,
      useAmount: String(values?.useAmount ?? 0),
      purCount: String(values?.purCount ?? 0),
      puredCount: String(values?.purCount ?? 0),
      bomAmount: String(values?.bomAmount ?? 0),
    })
      .then(async res => {
        if (item?.equotationRequest?.purchaseItem) {
          item?.equotationRequest?.purchaseItem && await purItemUpdate(item?.equotationRequest?.purchaseItem?.id ?? '', {
            ...item.equotationRequest.purchaseItem,
            count: purCount,
          })

        }
        onSuccessCb({ ...res, puredCount: String(values?.purCount ?? 0) });
        notification.success({ placement: 'top', message: t('sale.updateSuccess') });
      })
      .catch(err => {
        notification.error({ placement: 'top', message: t('common.saveFAil') });
      })
      .finally(() => {
        setOkLoading(false);
      })

  }

  return <Modal title={t("requirement.matInfo")} open={true}
    onCancel={onClose} onOk={() => form.submit()}
    okButtonProps={{ loading: okLoading }} width={800}
  >
    <Descriptions items={desc} />
    <Divider style={{ borderBlockStart: "#172B4D" }}>
      {t("requirement.editNum")}
    </Divider>
    <Form<FieldType> form={form} size="large" onFinish={submit} >
      <Form.Item label={t("requirement.requireCount")} name="useAmount" rules={[
        { required: true, message: t('requirement.plReqCount') }
      ]}>
        <InputNumber changeOnWheel formatter={val => numFormmater(Number(val || 0))} min={0} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item label={t("requirement.requirmentQuantity")} name="purCount" rules={[
        { required: true, message: t('requirement.plPurCount') }
      ]}>
        <InputNumber changeOnWheel formatter={val => numFormmater(Number(val || 0))} min={0} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item label={t("requirement.bomAmount")} name="bomAmount" rules={[
        { required: true, message: t('requirement.bomAmount') }
      ]}>
        <InputNumber changeOnWheel formatter={val => numFormmater(Number(val || 0))} min={0} style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  </Modal>
};

export default ItemInfo;